<script>
/* globals route axios moment */

import ErrorHandler from '../../core/ErrorHandler';

export default {
  props: {
    resource: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      total: 0,
      today: 0,
      month: 0,
      compareMonthToLastYear: 0,
    };
  },

  computed: {
    tagClass() {
      if (this.compareMonthToLastYear === 0) {
        return '';
      }
      return this.compareMonthToLastYear > 0
        ? 'bg-green-lightest text-green'
        : 'bg-red-lightest text-red';
    },

    tagIcon() {
      if (this.compareMonthToLastYear === 0) {
        return 'graphic-moderate';
      }
      return this.compareMonthToLastYear > 0 ? 'good-trends' : 'bad-trends';
    },

    currentMonth() {
      return moment().format('MMMM');
    },
  },

  created() {
    axios
      .get(route('api.widgets.show', `${this.resource}-count`))
      .then(({ data }) => {
        this.total = data.total;
        this.today = data.today;
        this.month = data.month;
        this.compareMonthToLastYear = data.compareMonthToLastYear;
      })
      .catch(error => new ErrorHandler(error));
  },

  render() {
    return this.$scopedSlots.default({
      total: this.total,
      today: this.today,
      month: this.month,
      compareMonthToLastYear: this.compareMonthToLastYear,
      tagClass: this.tagClass,
      tagIcon: this.tagIcon,
      currentMonth: this.currentMonth,
    });
  },
};
</script>